<template>
  <div class="table-input">
    <div class="table-input-form" v-if="isEditing">
      <div class="form-group">
        <quill-editor v-model="text" :options="editorOptions"></quill-editor>
        <div class="form-group__config">
          <label class="config">
            <input type="checkbox" v-model="isTableHeaderEnabled" />
            <p>1行目を見出しにする</p>
          </label>
          <label class="config">
            <input type="checkbox" v-model="isRowHeaderEnabled" />
            <p>1列目を見出しにする</p>
          </label>
        </div>
        <div class="form-group__footer">
          <a class="btn-green" @click="onEndEdit()">追加</a>
          <a class="btn-green" @click="onDeleteInput()">削除</a>
        </div>
      </div>
    </div>
    <div class="table-input-preview input-preview" v-else>
      <div
        class="table-input-preview-text"
        :class="{
          'table-input-preview-text--row-head': isRowHeaderEnabled,
          'table-input-preview-text--table-head': isTableHeaderEnabled,
        }"
        v-html="text.replace(/\n/g, '<br/>')"
      />
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import Quill from 'quill';
import QuillTable from 'quill-table';
import 'quill-table/src/css/quill.table.css';
import footerMenu from '../input-footer-menu.vue';

Quill.register(QuillTable.TableCell);
Quill.register(QuillTable.TableRow);
Quill.register(QuillTable.Table);
Quill.register(QuillTable.Contain);
Quill.register('modules/table', QuillTable.TableModule);

const toolbar = [
  [{ table: 'newtable_3_2' }, { table: 'append-row' }, { table: 'append-col' }],
  ['bold', 'italic', 'underline', 'strike'],
  ['image', 'link'],

  [{ color: [] }],
  [{ align: [] }],

  ['clean'],
];

export default {
  name: 'TableEditor',
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          text: this.text,
          isRowHeaderEnabled: this.isRowHeaderEnabled,
          isTableHeaderEnabled: this.isTableHeaderEnabled,
        },
        action: 'table',
        id: this.id,
      };
    },
    valid() {
      return this.text.length;
    },
    editorOptions() {
      return {
        modules: {
          table: true,
          toolbar,
        },
      };
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('テキストを入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
  components: {
    'footer-menu': footerMenu,
  },
  data() {
    return {
      isEditing: false,
      text: this.value.text,
      isRowHeaderEnabled: this.value.isRowHeaderEnabled,
      isTableHeaderEnabled: this.value.isTableHeaderEnabled,
    };
  },
};
</script>

<style lang="scss" scoped>
// 直のnewtableボタンにデフォルトでアイコンがついてないのでつける
.quill-editor ::v-deep button.ql-table[value='newtable_3_2']::after {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABcSURBVEhL3YsxDgBACML8/6fvNhd0aGCyCUuBOsULR5hGToStSHl8oB4fqMcH6rtIRZhGToStSHl8oB4fqMcH6rtIRZhGToStSHl8oB4fqMcH6rtIRZhGTk5Q9QFCcv8BMZAsCwAAAABJRU5ErkJggg==');
}

.table-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.form-group {
  &__config {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.config {
  display: flex;
  align-items: center;
}

.table-input-preview-text {
  font-size: 1.4rem;

  &--row-head {
    ::v-deep {
      td:first-child {
        background-color: #fff7de;
      }
    }
  }

  &--table-head {
    ::v-deep {
      tr:first-child {
        background-color: #fff7de;
      }
    }
  }

  ::v-deep {
    table {
      min-width: 100%;
    }

    $border: 1px solid #efefef;
    tr {
      border-top: $border;

      &:last-child {
        border-bottom: $border;
      }
    }

    td {
      padding: 8px 12px;
      border-left: $border;

      &:last-child {
        border-right: $border;
      }
    }

    .ql-align-center {
      text-align: center;
    }

    .ql-align-right {
      text-align: right;
    }
  }
}
.ql-editor {
  font-size: 15px;
}
</style>
